import createHeading from './createHeading';

export default createHeading('h3');
